import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

interface NicknameModalProps {
  onJoin: (nickname: string) => void;
}

export const NicknameModal = ({ onJoin }: NicknameModalProps) => {
  const [nickname, setNickname] = useState('');
  const { t } = useLanguage();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nickname.trim()) {
      onJoin(nickname.trim());
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">
          Chat with Coder
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          {t('modal.enter_nickname')}
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder={t('modal.nickname_placeholder')}
            className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
            maxLength={20}
            autoFocus
          />
          <button
            type="submit"
            className="w-full mt-4 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg transition-colors"
          >
            {t('modal.join')}
          </button>
        </form>
      </div>
    </div>
  );
};
